import React from 'react';
import {
  typeName,
  qualify,
  iconName,
  pluginName,
} from '@packages/systems/wfdl-Qualified';
import {withMeta, withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {
  TText,
  TListOfElement,
  TEnum,
  TRecord,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const basicPlugin = Plugins.name('Basic');

const maybeAddUnstyled = (list: any) => (classes: Immutable.List<string>) => {
  return list?.unstyled ? classes.push('w-list-unstyled') : classes;
};

const List = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const Tag = data.tag;
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const listClasses = classes.update(maybeAddUnstyled(data.list));
    const listAttributes = attributes.set('role', 'list');

    return (
      <Tag {...generateAttributes(listAttributes, listClasses)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

const config = createDevlinkAtom({
  showEmpty: true,
  icon: {type: 'Component', value: [basicPlugin, iconName('List')]},
  displayName: 'List',
  constraints: {
    children: [
      {
        is: 'ListItem',
        name: 'Non-List Item',
        rule: 'RequireOnly',
      },
    ],
  },
  render: List,
  fields: {
    children: TListOfElement,
    tag: withSystem(
      {
        label: 'Type',
        defaultValue: 'ul',
        isLocalizable: true,
      },
      TEnum({
        ul: 'Unordered',
        ol: 'Ordered',
      })
    ),
    list: TRecord({
      type: withSystem(
        {
          private: true,
          defaultValue: 'list',
          label: 'private label',
        },
        TText
      ),
      unstyled: withMeta(
        {
          labels: {
            false: 'Bullets',
            true: 'No bullets',
          },
        },
        withSystem(
          {label: 'Style', isLocalizable: true},
          TTypeConstructor(
            qualify(pluginName('Basic'), typeName('LabeledBoolean'))
          )
        )
      ),
    }),
  },
});

export default config;
